import { render } from "./MergeDialog.vue?vue&type=template&id=b5e64b52"
import script from "./MergeDialog.vue?vue&type=script&lang=js"
export * from "./MergeDialog.vue?vue&type=script&lang=js"

import "./MergeDialog.vue?vue&type=style&index=0&id=b5e64b52&lang=less"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__